<template>
  <div
    class="asc-accordion--container"
    :class="{ 'asc-accordion--container-flat': flat }"
  >
    <v-expansion-panels
      ref="ascAccordionGroup"
      v-model="model"
      class="asc-accordion"
      active-class="asc-acordion--item-open"
      :accordion="accordion"
      :multiple="multiple"
      :disabled="disabled"
      :readonly="readonly"
      :flat="flat"
      :tile="tile"
      :inset="inset"
    >
      <slot></slot>
    </v-expansion-panels>
  </div>
</template>

<script>
import { AscAccordionPropsMixin } from '@/components/mixins'

export default {
  name: 'AscAccordion',

  mixins: [AscAccordionPropsMixin],

  data() {
    return {
      innerValue: this.value,
    }
  },

  computed: {
    model: {
      get() {
        return this.innerValue
      },
      set(value) {
        this.innerValue = value
      },
    },
  },

  watch: {
    value(val) {
      this.innerValue = val
    },
  },
}
</script>

<style lang="scss">
.asc-accordion--container {
  &:not(.asc-accordion--container-flat) {
    border: 1px solid $gray-400;
  }
}
</style>
